import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIPayableModel } from "../payableModel";

import { IPayableDetail } from "../payableTypes";
import moment, { Moment } from "moment";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import useNavModel from "@/model/navModel";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows,
        loadData, setSelectedRowKeys, setDescRows,
    } = useIPayableModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (record: IPayableDetail) => {
        let { tradeCode, tradeTypeCode } = record
        if (tradeTypeCode === "trade-type.maintenance") {//维修工单
            return replaceNav(selectedNavId, "2-2-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.sale-return") {//销售退货
            return replaceNav(selectedNavId, "2-4-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.sale") {//销售单
            return replaceNav(selectedNavId, "2-3-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.purchase") {//采购单
            return replaceNav(selectedNavId, "3-1-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.purchase-return") {//采购退货
            return replaceNav(selectedNavId, "3-2-3", { id: tradeCode as string, mode: "look", }, true);
        }
    }
    const columns: ColumnsType<IPayableDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 60,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            // title: '单据编码',
            title: Locale["Document No."],
            width: 150,
            dataIndex: 'tradeCode',
            fixed: "left",
            render: (text, record) => <span onClick={() => onLook(record)} className="click-span">{text}</span>
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 180,
            dataIndex: 'tradeTypeCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 100,
            dataIndex: 'userName',
        }, {
            // title: '客户属性',
            title: Locale["Customer Attribute"],
            width: 130,
            dataIndex: 'userType',
        }, {
            // title: '应付金额',
            title: Locale["Payable Amount"],
            width: 130,
            dataIndex: 'receivableAmount',
        }, {
            // title: '制单人',
            title: Locale["Creator"],
            width: 130,
            dataIndex: 'createUser',
        }, {
            // title: '制单时间',
            title: Locale["Creation Time"],
            width: 130,
            dataIndex: 'creationTime',
            render: (text) => momentFormat(text)
        }
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: IPayableDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPayableDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
